<template>
  <article
    class="garage-price-list"
    itemprop="hasOfferCatalog"
    itemscope
    itemtype="http://schema.org/OfferCatalog"
  >
    <div v-if="!!popularServices?.length">
      <h2 class="garage-price-list__header">Popularne Usługi</h2>
      <section class="garage-price-list__price-list">
        <GaragePriceElement
          v-for="(service, index) in popularServices"
          :service="service"
          :key="service.serviceId || index"
          v-show="limit ? index < 3 : true"
        />
      </section>
    </div>
    <div v-if="!!otherServices?.length">
      <h2 class="garage-price-list__header garage-price-list__header--other">Inne usługi</h2>
      <section class="garage-price-list__price-list">
        <template
          v-for="(service, index) in otherServices"
          :key="service.id || index"
        >
          <GaragePriceElement
            v-if="limit ? index < 5 : true"
            :service="service"
          />
        </template>
      </section>
    </div>

    <div
      v-if="!popularServices?.length && !otherServices?.length"
      class="garage-price-list__no-results"
    >
      <div v-if="route.meta.layout === 'modal'">
        <h2><span>Ups...</span> nic nie znaleźliśmy</h2>
        <p>Jeśli nie możesz znaleźć odpowiedniej usługi, opisz problem z samochodem, a warsztat zdiagnozuje usterkę i
          przygotuje wycenę naprawy.
        </p>

        <DmButton
          title="Opisz problem"
          @click="emits('set-other-reason-tab')"
        />
      </div>
    </div>

    <NuxtLink
      v-if="limit && !!garagePriceList?.length"
      :to="route.path + '/services'"
    >
      <DmButton
        tertiary
        class="w-100 mt-5"
        title="Zobacz więcej"
      >
      </DmButton>
    </NuxtLink>
  </article>
</template>

<script setup lang="ts">
import GaragePriceElement from '@/components/GaragePriceElement.vue';
import { DmButton } from '@dobrymechanik/vue-ui-v2';

interface IProps {
  garagePriceList?: any[];
  limit?: boolean;
}

interface IEmits {
  (name: 'set-other-reason-tab'): void;
}

// props
const props = withDefaults(defineProps<IProps>(), {
  limit: false
});

// emits
const emits = defineEmits<IEmits>();

// use 
const route = useRoute();

// methods
const nuxtLinkTo = (serviceId: string) => {
  return route.meta.layout === 'modal' ? `${route.path}/${serviceId}` : `${route.path}/services/${serviceId}`;
};

// computed 
const popularServices = computed(() => {
  return props.garagePriceList?.filter(service => service.popular);
});

const otherServices = computed(() => {
  return props.garagePriceList?.filter(service => !service.popular);
});

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-price-list.scss');
</style>